import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

import { abilities } from '../../utils/constants'

am4core.useTheme(am4themesAnimated)

function createAxis(chart) {
  const textColor = '#737985'
  const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
  categoryAxis.dataFields.category = 'age'
  categoryAxis.renderer.grid.template.location = 0
  categoryAxis.renderer.minGridDistance = 20
  categoryAxis.renderer.labels.template.fontSize = 10
  categoryAxis.renderer.labels.template.fill = am4core.color(textColor)
  categoryAxis.renderer.grid.template.disabled = true
  categoryAxis.renderer.labels.template.adapter.add('textOutput', text => text ? text.slice(0, 13) : text)

  const valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
  valueAxis.calculateTotals = true
  valueAxis.min = 0
  valueAxis.max = 100
  valueAxis.strictMinMax = true
  valueAxis.renderer.labels.template.fontSize = 10
  valueAxis.renderer.labels.template.fill = am4core.color(textColor)
  valueAxis.renderer.labels.template.adapter.add('text', text => text + '%')
  valueAxis.renderer.opposite = true
}

function addPercentages(chart) {
  abilities.forEach(ability => {
    const series = chart.series.push(new am4charts.ColumnSeries())
    series.dataFields.valueY = ability.name
    series.dataFields.valueYShow = 'totalPercent'
    series.dataFields.categoryX = 'age'
    series.stacked = true
    series.stroke = am4core.color(ability.color)
    series.fill = am4core.color(ability.color)

    series.columns.template.tooltipText = '{valueY.totalPercent.formatNumber("#.00")}%'
    series.tooltip.getFillFromObject = false
    series.tooltip.background.fill = am4core.color('white')
    series.tooltip.autoTextColor = false
    series.tooltip.label.fill = am4core.color('black')
  })
}

export default function setStackedChartConfig(chart, categoriesData) {
  const dataMapped = categoriesData.map(categoryData =>
    categoryData.skillPercentages.map(ageData => {
      const { ageRangeVO } = ageData
      const dataRender = {}
      ageData.skillPercentageVOs.map(percentage => {
        if (percentage.percentage > 0) dataRender[percentage.skill.name] = percentage.percentage
      })
      dataRender.category = categoryData.category.name
      dataRender.age = `${ageRangeVO.minAge} a ${ageRangeVO.maxAge} años - ${categoryData.category.name}`
      return dataRender
    })
  )
  chart.data = dataMapped.reduce((array, categoryData) => array.concat(categoryData), [])
  createAxis(chart)
  addPercentages(chart)
}
